(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  class CategoryCarouselPager {
    constructor(root) {
      this.slider = root.querySelector('[id^="Slider-"]');
      this.prevButton = root.querySelector('[data-carousel-direction="prev"]');
      this.nextButton = root.querySelector('[data-carousel-direction="next"]');
      if (!this.slider || !this.prevButton || !this.nextButton) return;

      // Buttons are intentionally NOT named "previous"/"next", so Dawn's own
      // SliderComponent (which assumes one gap per item instead of
      // (visibleCount - 1) gaps, overshooting the container width) never
      // binds to them. This class is the only thing driving the scroll, so
      // there's no second handler fighting over the scroll position.
      this.target = this.slider.scrollLeft;
      this.maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

      this.prevButton.addEventListener('click', () => this.page(-1));
      this.nextButton.addEventListener('click', () => this.page(1));

      // Native CSS scroll-snap is disabled on this component (see the
      // stylesheet), so a manual swipe/drag can rest at any arbitrary pixel.
      // Once scrolling stops, snap it to the nearest page boundary ourselves.
      this.scrollSettleTimer = null;
      this.slider.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = window.setTimeout(() => this.snapToNearestPage(), 120);
      });
    }

    snapToNearestPage() {
      const width = this.pageWidth();
      this.maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const nearest = Math.min(this.maxScroll, Math.max(0, Math.round(this.slider.scrollLeft / width) * width));
      this.target = nearest;
      if (Math.abs(this.slider.scrollLeft - nearest) > 1) {
        this.slider.scrollTo({ left: nearest, behavior: 'smooth' });
      }
    }

    pageWidth() {
      const items = this.slider.querySelectorAll('[id^="Slide-"]');
      if (items.length < 2) return this.slider.clientWidth;

      const first = items[0].getBoundingClientRect();
      const second = items[1].getBoundingClientRect();
      const itemWidth = first.width;
      const gap = second.left - first.right;
      const visibleCount = Math.max(1, Math.round(this.slider.clientWidth / (itemWidth + gap)));

      return visibleCount * itemWidth + (visibleCount - 1) * gap;
    }

    page(direction) {
      this.maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      this.target = Math.min(this.maxScroll, Math.max(0, this.target + direction * this.pageWidth()));
      this.slider.scrollTo({ left: this.target, behavior: 'smooth' });
    }
  }

  document.querySelectorAll('[id^="CategoryCarousel-"]').forEach((root) => new CategoryCarouselPager(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.heroBanner = this.classList.contains('header-wrapper--transparent')
        ? document.querySelector('.banner')
        : null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.heroBanner) {
        const pastHero = this.heroBanner.getBoundingClientRect().bottom <= 0;
        this.classList.toggle('header--scrolled', pastHero);
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
